import React, { useState } from "react";
import { ProSidebarProvider, Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { tokens } from "../../theme";
import {
  HomeOutlined,
  CalendarTodayOutlined,
  // HelpOutlined,
  // BarChartOutlined,
  // PieChartOutlineOutlined,
  // TimelineOutlined,
  MenuOutlined,
  // MapOutlined,
  Settings,
  FeedOutlined,
  PaymentOutlined,
  PostAddOutlined,
} from "@mui/icons-material";
import {
  selectSponserName,
  selectSponserEmail,
  selectSponserID,
  selectCurrentToken,
  selectImageUrl,
} from "../../features/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { setImageUrl } from "../../features/auth/authSlice";

const Item = ({
  title,
  to,
  icon,
  selected,
  setSelected,
}: {
  title: string;
  to: string;
  icon: any;
  selected: string;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{ color: colors.grey[100] }}
      onClick={() => setSelected(title)}
      icon={icon}
      href={to}
      component={<Link to={to} />}
    >
      <Typography>{title}</Typography>
    </MenuItem>
  );
};
const SidebarLocal = ({
  setShowSideNav,
}: {
  setShowSideNav: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollasped, setIsCollasped] = useState(false);
  const [selected, setSelected] = useState("Dashboard" as string);
  const name = useSelector(selectSponserName);
  const email = useSelector(selectSponserEmail);
  const sponserId = useSelector(selectSponserID);
  const token = useSelector(selectCurrentToken);
  const profileImageUrl = useSelector(selectImageUrl);

  const handelFileChange = async (e: any) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    const response: any = await fetch(
      process.env.REACT_APP_ENV === "local"
        ? `/sponser/updateImage/${sponserId}`
        : process.env.REACT_APP_BACKEND_API +
            `/sponser/updateImage/${sponserId}`,
      {
        method: "PUT",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();
    dispatch(
      setImageUrl({
        profileImageUrl: data?.imageUrl,
      })
    );
  };

  return (
    <Box
      display={"flex"}
      sx={{
        "& .ps-menu-root": {
          backgroundColor:
            theme.palette.mode === "dark"
              ? `${colors.primary[400]} !important`
              : `${colors.primary[900]} !important`,
        },
        "& .ps-sidebar-root": {
          borderRight: 0,
        },
        "& .ps-menu-button": {
          height: "30px !important",
        },
        "& .ps-sidebar-container": {
          background:
            theme.palette.mode === "dark"
              ? `${colors.primary[400]} !important`
              : `${colors.primary[900]} !important`,
        },
        "& .ps-menu-button:hover": {
          color: "#868dfb !important",
          backgroundColor: `${colors.primary[400]} !important`,
        },
        "& .ps-menu-button:active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebarProvider>
        <Sidebar defaultCollapsed={isCollasped}>
          <Menu>
            <MenuItem
              icon={
                isCollasped ? (
                  <MenuOutlined
                    onClick={() => {
                      setIsCollasped((prev: boolean) => !prev);
                      setShowSideNav((prev) => !prev);
                    }}
                  />
                ) : undefined
              }
              style={{
                margin: "5px 0 5px 0",
                color: colors.grey[100],
              }}
            >
              {/* ADMIN INFO */}
              {!isCollasped && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  ml="15px"
                >
                  <Typography variant="h3" color={colors.grey[100]}>
                    DASHBOARD
                  </Typography>
                  <IconButton
                    onClick={() => {
                      setIsCollasped((prev) => !prev);
                      setShowSideNav((prev) => !prev);
                    }}
                  >
                    <MenuOutlined />
                  </IconButton>
                </Box>
              )}
            </MenuItem>

            {!isCollasped && (
              <Box mb="3px">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  position={"relative"}
                >
                  <label htmlFor="userImage">
                    {!!profileImageUrl ? (
                      <img
                        alt="profile-user"
                        width="100px"
                        height="100px"
                        className="h-[100px]"
                        src={
                          process.env.REACT_APP_BACKEND_API +
                          "/" +
                          profileImageUrl
                        }
                        style={{ cursor: "pointer", borderRadius: "50%" }}
                      />
                    ) : (
                      <img
                        alt="profile-user"
                        width="100px"
                        height="100px"
                        className="h-[100px]"
                        style={{ cursor: "pointer", borderRadius: "50%" }}
                      />
                    )}
                  </label>
                  <input
                    className="absolute left-0 right-0 top-0 bottom-0"
                    type={"file"}
                    id="userImage"
                    accept="image/*"
                    hidden
                    onChange={(e) => handelFileChange(e)}
                  />
                </Box>
                <Box textAlign="center">
                  <Typography
                    variant="h2"
                    color={colors.grey[100]}
                    fontWeight="bold"
                    sx={{ m: "10px 0 0 0" }}
                  >
                    {name}
                  </Typography>
                  <Typography variant="h5" color={colors.greenAccent[500]}>
                    {email}
                  </Typography>
                </Box>
              </Box>
            )}

            <Box
              onClick={() => {
                setIsCollasped((prev: boolean) => !prev);
                setShowSideNav((prev) => !prev);
              }}
              paddingLeft={isCollasped ? undefined : "10%"}
            >
              <Item
                title="Dashboard"
                to="/dashboard"
                icon={<HomeOutlined />}
                selected={selected}
                setSelected={setSelected}
              />

              <Typography
                variant="h6"
                color={colors.grey[300]}
                sx={{ m: "15px 0 5px 20px" }}
              >
                Data
              </Typography>
              {/* <Item
                title="Creators"
                to="/creators"
                icon={<PeopleOutlined />}
                selected={selected}
                setSelected={setSelected}
              /> */}
              <Item
                title="Feeds"
                to="/feeds"
                icon={<FeedOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Add Feeds"
                to="/addFeeds"
                icon={<FeedOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Landing Pages"
                to="/landingPage"
                icon={<PostAddOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Orders"
                to="/viewOrders"
                icon={<FeedOutlined />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title="Payments"
                to="/payments"
                icon={<PaymentOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
              {/* <Item
                title="Invoices Balances"
                to="/invoices"
                icon={<ReceiptOutlined />}
                selected={selected}
                setSelected={setSelected}
              /> */}

              <Typography
                variant="h6"
                color={colors.grey[300]}
                sx={{ m: "15px 0 5px 20px" }}
              >
                Pages
              </Typography>
              <Item
                title="Settings"
                to="/form"
                icon={<Settings />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Notifications"
                to="/calendar"
                icon={<CalendarTodayOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
              {/* <Item
                title="FAQ Page"
                to="/faq"
                icon={<HelpOutlined />}
                selected={selected}
                setSelected={setSelected}
              /> */}

              {/* <Typography
                variant="h6"
                color={colors.grey[300]}
                sx={{ m: "15px 0 5px 20px" }}
              >
                Charts
              </Typography>
              <Item
                title="Bar Chart"
                to="/bar"
                icon={<BarChartOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Pie Chart"
                to="/pie"
                icon={<PieChartOutlineOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Line Chart"
                to="/line"
                icon={<TimelineOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Geography Chart"
                to="/geography"
                icon={<MapOutlined />}
                selected={selected}
                setSelected={setSelected}
              /> */}
            </Box>
          </Menu>
        </Sidebar>
      </ProSidebarProvider>
    </Box>
  );
};

export default SidebarLocal;
